var e={exports:{}};export{e as __module};
//# sourceMappingURL=localizedFormat.js.map
